import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SiteMapStore } from '../../site-map.store';
import { SiteMapPopup } from '../../site-map.types';

const MAX_TITLE_LENGTH = 20;

@Component({
  selector: 'app-site-map-popup',
  standalone: true,
  templateUrl: './map-popup.component.html',
  styleUrls: ['./map-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, DecimalPipe, TranslateModule],
})
export class SiteMapPopupComponent {
  readonly popup = input.required<SiteMapPopup>();
  readonly showDetailsLink = input(true);
  readonly openBlast = output<number>();

  protected readonly store = inject(SiteMapStore);

  protected readonly blast = computed(() => this.store.blastsById().get(this.popup().blastId) ?? null);
  protected readonly holePopup = computed(() => {
    const popup = this.popup();
    return popup.kind === 'hole' ? popup : null;
  });
  protected readonly selectedKpi = computed(() => this.store.blastSelectedKpi(this.popup().blastId));
  protected readonly configuredKpis = computed(() => this.store.blastConfiguredKpis(this.popup().blastId));

  protected truncate(name: string | null | undefined): string {
    if (!name) return '';
    return name.length > MAX_TITLE_LENGTH ? `${name.slice(0, MAX_TITLE_LENGTH)}...` : name;
  }

  protected onOpenBlast(event: Event): void {
    event.preventDefault();
    this.openBlast.emit(this.popup().blastId);
  }
}
